import styled from 'styled-components'

export const CustomCompleteAnatomyContainer = styled.div`
  div:not(:last-of-type) {
    margin-bottom: 2.5rem;
  }

  h4 {
    font-weight: 500;
    font-size: 20px;
    color: var(--grey2);
    margin-bottom: 1.5rem;
  }
`
